export default class DeviceAdded {
  static type = 'DeviceAdded';
  constructor(deviceId) {
    if (typeof deviceId !== 'string') throw new TypeError('deviceId must be a string')
    this.deviceId = deviceId;
  }
}
